var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainSectionFlagUsaImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 142,
    viewBox: "0 0 120 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_69070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 0H0V142H150V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 17.75H0V35.5H150V17.75Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 53.25H0V71H150V53.25Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 88.75H0V106.5H150V88.75Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 124.25H0V142H150V124.25Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.25 0H0V71H106.25V0Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7334 29.0858L39.051 33.9855H33.6091L38.0125 37.0122L36.3301 41.9116L40.7334 38.8849L45.1339 41.9116L43.4519 37.0122L47.8553 33.9855H42.413L40.7334 29.0858Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.413 51.6672L40.7334 46.7678L39.051 51.6672H33.6091L38.0125 54.6942L36.3301 59.5936L40.7334 56.5666L45.1339 59.5936L43.4519 54.6942L47.8553 51.6672H42.413Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4144 51.6672L17.7344 46.7678L16.052 51.6672H10.6101L15.0135 54.6942L13.331 59.5936L17.7344 56.5666L22.1353 59.5936L20.4533 54.6942L24.8559 51.6672H19.4144Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7344 29.0858L16.052 33.9855H10.6101L15.0135 37.0122L13.331 41.9116L17.7344 38.8849L22.1353 41.9116L20.4533 37.0122L24.8559 33.9855H19.4144L17.7344 29.0858Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7334 11.4037L39.051 16.3039H33.6091L38.0125 19.3309L36.3301 24.2303L40.7334 21.2032L45.1339 24.2303L43.4519 19.3309L47.8553 16.3039H42.413L40.7334 11.4037Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7344 11.4036L16.052 16.3038H10.6101L15.0135 19.3308L13.331 24.2302L17.7344 21.2032L22.1353 24.2302L20.4533 19.3308L24.8559 16.3038H19.4144L17.7344 11.4036Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.732 29.0858L62.05 33.9855H56.6082L61.0111 37.0122L59.3295 41.9116L63.732 38.8849L68.1334 41.9116L66.4509 37.0122L70.8543 33.9855H65.4124L63.732 29.0858Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4124 51.6672L63.732 46.7678L62.05 51.6672H56.6082L61.0111 54.6942L59.3295 59.5936L63.732 56.5666L68.1334 59.5936L66.4509 54.6942L70.8543 51.6672H65.4124Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4115 51.6672L86.7316 46.7678L85.0491 51.6672H79.6077L84.0102 54.6942L82.3282 59.5936L86.7316 56.5666L91.1325 59.5936L89.4501 54.6942L93.8534 51.6672H88.4115Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7316 29.0858L85.0491 33.9855H79.6077L84.0102 37.0122L82.3282 41.9116L86.7316 38.8849L91.1325 41.9116L89.4501 37.0122L93.8534 33.9855H88.4115L86.7316 29.0858Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.732 11.4037L62.05 16.3039H56.6082L61.0111 19.3309L59.3295 24.2303L63.732 21.2032L68.1334 24.2303L66.4509 19.3309L70.8543 16.3039H65.4124L63.732 11.4037Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7316 11.4037L85.0491 16.3039H79.6077L84.0102 19.3309L82.3282 24.2303L86.7316 21.2032L91.1325 24.2303L89.4501 19.3309L93.8534 16.3039H88.4115L86.7316 11.4037Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_69070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H108C114.627 0 120 5.37258 120 12V130C120 136.627 114.627 142 108 142H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSectionFlagUsaImg);
export default __webpack_public_path__ + "static/media/main-section-flag-usa-img.4a226d619b0c81dbacdeee049a111987.svg";
export { ForwardRef as ReactComponent };